import Immutable from 'immutable';

const GroupIdpListRecord = Immutable.Record({
  id: undefined,
  name: undefined,
  groupId: undefined,
  idpList: undefined,
});

export default
  class GroupIdpList extends GroupIdpListRecord { }



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/GroupIdpList/model.js